import { render, staticRenderFns } from "./modalCopyRevenue.vue?vue&type=template&id=127c5830"
import script from "./modalCopyRevenue.vue?vue&type=script&lang=js"
export * from "./modalCopyRevenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports